import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import Table from "../../Components/Enquiries/Table";
import { toast } from "react-toastify";
import moment from "moment";
import { Form, Formik } from "formik";
import SideModal from "../../Components/SideModal";
import SearchFilterBox from "../../Components/SearchFilterBox";
import AddEnquiry from "../../Components/Enquiries/AddEnquiry";
import DeleteEnquiries from "../../Components/Enquiries/Delete";
import DateRange from "../../Components/DateRange";
import MatchingInventories from "../../Components/Enquiries/MatchingInventories";
import { useNavigate } from "react-router-dom";
import EditEnquiry from "../../Components/Enquiries/EditEnquiry";
import AddDeal from "../../Components/Properties/AddDeal";
import useDeal from "../../utilities/addDeal.api";
import { AddBtn } from "../../Components/Styles/InputStyles";
import Notes from "../../Components/Enquiries/Note";

const Enquiries = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const navigate = useNavigate();

  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState();
  const [isAddEnquiries, setIsAddEnquiries] = useState(false);
  const [key, setKey] = useState("");
  const [isEditEnquiries, setIsEditEnquiries] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isDeleteEnquiries, setIsDeleteEnquiries] = useState(false);
  const [isMatchDrawerOpen, setIsMatchDrawerOpen] = useState(false);
  const [inventoryList, setInventoryList] = useState([]);
  const [isAddDeal, setIsAddDeal] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [isViewNotes,setIsViewNotes] =useState(false)
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );

  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD"),
  );

  const initialValues = {
    startDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const getFilterType = (type) => {
    switch (type) {
      case 1:
        return "MOBILE";
      case 2:
        return "NAME";
      default:
        return "";
    }
  };

  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}&startDate=${params.startDate || ""}&endDate=${params.endDate || ""}`;
    let url = `${Config.apiUrl}/enquiry/list?${query}`;

    const response = await axios.get(url, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });

    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) {
      toast.error("Failed to fetch enquiries");
    } else {
      setApiData(res?.data);
    }
  };
  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const handleFilterChange = (values) => {
    const type = getFilterType(values.filterType);
    setFilterType(type);
    setSearchQuery(values.searchQuery);
    getListMutate({
      searchQuery: values.searchQuery,
      filterType: type,
      startDate,
      endDate,
    });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate({ searchQuery, filterType, startDate, endDate });
    }, 50);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  //------- Add Enquiry -------
  const addEnquiryFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/enquiry/add`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddEnquiriesSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsAddEnquiries(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddEnquiriesError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addEnquiriesLoading, mutate: addEnquiryMutate } =
    useMutation(addEnquiryFunction, {
      onSuccess: onAddEnquiriesSuccess,
      onError: onAddEnquiriesError,
    });

  //------- Edit Enquiries -------
  const editEnquiriesFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/enquiry/edit`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };
  const onEditEnquiriesSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsEditEnquiries(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onEditEnquiriesError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editEnquiriesLoading, mutate: editEnquiriesMutate } =
    useMutation(editEnquiriesFunction, {
      onSuccess: onEditEnquiriesSuccess,
      onError: onEditEnquiriesError,
    });

  //------- Delete Enquiry -------
  const deleteEnquiriesFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/enquiry/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteEnquiriesSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsDeleteEnquiries(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deleteEnquiriesError = (data) => {
    setIsDeleteEnquiries(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteEnquiriesLoading, mutate: deleteEnquiriesMutate } =
    useMutation(deleteEnquiriesFunction, {
      onSuccess: deleteEnquiriesSuccess,
      onError: deleteEnquiriesError,
    });


 //----fetch inventory matching with the tenants-------   
  const fetchMatchingInventories = async (params) => {
    let url = `${Config.apiUrl}/enquiry/${params.id}/matching-inventories`;

    const response = await axios.get(url, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });

    return response.data;
  };

  const getMatchingSuccess = (res) => {
    if (res.isSuccess === false) {
      toast.error(res.msg || "Failed to fetch inventories");
    } else {
      setInventoryList(res?.data || []);
    }
  };

  const getMatchingError = (err) => {
    toast.error("Something went wrong");
  };

  const {
    isLoading: inventoryLoading,
    mutate: getInventoryListMutate,
  } = useMutation(fetchMatchingInventories, {
    onSuccess: getMatchingSuccess,
    onError: getMatchingError,
  });

  //-------------Add Deal----------------
  const { addDealMutate, addDealLoading } = useDeal({
    token: user.token,
    onSuccessCallback: () => {
      setIsMatchDrawerOpen(false);
      setIsAddDeal(false);
      getListMutate({ searchQuery, filterType });
    },
  });

  const handleEnquiryClose = () => {
    setIsDeleteEnquiries(false);
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "", startDate, endDate });
  };

  const handleViewInventory = (inventory) => {
    navigate("/inventory/details", {
      state: {
        inventoryId: inventory.id,
      },
    });
  };

  const handleCreateDeal = (inventory) => {
    setSelectedInventory(inventory);
    setIsAddDeal(true);
  };

  const handleDealClose = () => {
    setIsAddDeal(false);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Enquiries
            <Underline />
          </BoxTitle>
          <Filters
            initialValues={initialValues}
            setIsAddEnquiries={setIsAddEnquiries}
            setKey={setKey}
          />
        </BoxHead>

        <SideModal
          isOpen={isAddEnquiries}
          onClose={() => setIsAddEnquiries(false)}
        >
          <AddEnquiry
            key={key} //Key is needed to reset the form
            setIsAddEnquiries={setIsAddEnquiries}
            addEnquiriesLoading={addEnquiriesLoading}
            addEnquiryMutate={addEnquiryMutate}
          />
        </SideModal>

        <SideModal
          isOpen={isEditEnquiries}
          onClose={() => setIsEditEnquiries(false)}
        >
          <EditEnquiry
            setIsEditEnquiries={setIsEditEnquiries}
            editEnquiriesLoading={editEnquiriesLoading}
            editEnquiriesMutate={editEnquiriesMutate}
            selectedData={selectedData}
          />
        </SideModal>
        <SideModal
            isOpen={isViewNotes}
            onClose={() => setIsViewNotes(false)}
        >
            <Notes
                isViewNotes={isViewNotes}
                setIsViewNotes={setIsViewNotes}
                selectedData={selectedData}
                getListMutate={() => getListMutate({ searchQuery, filterType, startDate, endDate })}
            />
        </SideModal>

        <SideModal
          isOpen={isMatchDrawerOpen}
          onClose={() => setIsMatchDrawerOpen(false)}
        >
          <MatchingInventories
            apiData={inventoryList}
            loading={inventoryLoading}
            handleClose={() => setIsMatchDrawerOpen(false)}
            onView={handleViewInventory}
            onDeal={handleCreateDeal}
            navigate={navigate}
          />
        </SideModal>

        <SideModal
          isOpen={isAddDeal}
          onClose={() => setIsAddDeal(false)}
          width="1/3"
          level="high"
        >
          <AddDeal
            selectedData={selectedInventory}
            handleClose={handleDealClose}
            addDealLoading={addDealLoading}
            addDealMutate={addDealMutate}
            selectedTableRow={selectedData}
          />
        </SideModal>

        <FilterTableWrapper>
          <FilterWrapper className="flex items-center justify-evenly">
            <div className="flex flex-col gap-3 md:flex-row md:justify-end md:items-center">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilters}
              />
              <DateRange
                submitHandler={(values) => {
                  const newStart = moment(values.startDate).format("YYYY-MM-DD");
                  const newEnd = moment(values.endDate).format("YYYY-MM-DD");

                  setStartDate(newStart);
                  setEndDate(newEnd);

                  getListMutate({
                    searchQuery,
                    filterType,
                    startDate: newStart,
                    endDate: newEnd,
                  });
                }}
                defaultLabel={`${moment(startDate).format("DD MMM yyyy")} - ${moment(endDate).format("DD MMM yyyy")}`}
              />
            </div>
          </FilterWrapper>
          {isDeleteEnquiries && (
            <DeleteEnquiries
              setIsDeleteEnquiries={setIsDeleteEnquiries}
              isDeleteEnquiries={isDeleteEnquiries}
              deleteEnquiriesLoading={deleteEnquiriesLoading}
              deleteEnquiriesMutate={deleteEnquiriesMutate}
              selectedData={selectedData}
              handleClose={handleEnquiryClose}
            />
          )}
          {!isLoading && (
            <TableWrapper>
              <Table
                apiData={apiData}
                selectedData={selectedData}
                setSelectedData={setSelectedData}
                setIsEditEnquiries={setIsEditEnquiries}
                getInventoryListMutate={getInventoryListMutate}
                setIsDeleteEnquiries={setIsDeleteEnquiries}
                setIsMatchDrawerOpen={setIsMatchDrawerOpen}
                setInventoryList={setInventoryList}
                setIsViewNotes={setIsViewNotes}
              />
              {(!apiData || apiData.length === 0) && <NotFoundModel />}
            </TableWrapper>
          )}
        </FilterTableWrapper>
        {/* </>
        )} */}
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  setIsAddEnquiries,
  setKey,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <AddBtn
            type="button"
            onClick={() => {
              setKey(moment().unix());
              setIsAddEnquiries(true);
            }}
          >
            {"Add Enquiry"}
          </AddBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;

const FilterContainer = tw.div`grid grid-cols-2 md:grid-cols-3 w-full gap-2 lg:gap-0 md:flex md:space-x-4 items-end mt-0 md:mt-0`;

export default Enquiries;
